import { OrchestratorErrorResponse } from 'types/api/orchestrator';
import {
  FetchReissuanceOrchOptions,
  OrchReissuanceRequest,
  OrchReissuanceResponse,
  ReissuanceErrorResponse,
  ReissuanceResponse
} from 'types/api/reissuance';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type FetchReissuanceOptions = {
  accessToken: string;
};

export function fetchReissuance({
  accessToken
}: FetchReissuanceOptions): FetchResponse<ReissuanceResponse, ReissuanceErrorResponse> {
  return fetchReq({
    body: {
      grant_type: 'authorization_probe_reissuance',
      probes_ref: [
        {
          data: {
            type: 'OTP'
          }
        }
      ]
    },
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    mark: 'initiate_identity_validation_reissuance',
    method: 'POST',
    url: endpoints.token.reissuance
  });
}

/* START GENAI@GHCOPILOT */
export function fetchOrchReissuance({
  accessToken,
  apikey,
  identityType,
  identityValue,
  isBiometricsEnabledDevice,
  isVdiDisabled
}: FetchReissuanceOrchOptions): FetchResponse<OrchReissuanceResponse, OrchestratorErrorResponse> {
  const body: OrchReissuanceRequest = {
    srcClientId: apikey,
    consumerIdentity: {
      identityProvider: 'SRC',
      identityType,
      identityValue
    },
    isBiometricsEnabledDevice
  };

  if (isVdiDisabled) {
    body.isVdiDisabled = isVdiDisabled;
  }

  return fetchReq({
    body,
    headers: {
      access_token: accessToken
    },
    mark: 'initiate_identity_validation_orchestrator_reissuance',
    method: 'POST',
    url: endpoints.orchestrator.reissuance
  });
}

/* END GENAI@GHCOPILOT */
